<script>
import Layout from "@/views/layouts/main.vue";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import CommonTableComponent from "@/components/table.vue";
import tableSearch from "@/mixins/tableSearch";
import ModalHistory from "@/views/pages/project/schedule/modals/ModalHistory";
import ModalScheduleCar from "@/views/pages/project/schedule/modals/ModalScheduleCar";
import ModalScheduleStaff from "@/views/pages/project/schedule/modals/ModalScheduleStaff";
import ModalTransportTreatment from "@/views/pages/project/schedule/modals/ModalTransportTreatment.vue";
import ModalSelectWasteOrServiceModalForSchedule
  from "@/views/pages/project/schedule/modals/ModalSelectWasteOrServiceModalForSchedule.vue";
import WorkReservationSpecificDatesInformation
  from "@/views/pages/project/schedule/components/work_reservation_specific_dates_information.vue";
import apiEndpoints from "@/services/apiEndpoints";
import WorkOrderInformationComponent from "@/views/pages/project/schedule/components/work_order_information.vue";
import ZzReservationStatus1Badge from "@/components/Common/ZzReservationStatus1Badge.vue";
import ZzReservationStatus2Badge from "@/components/Common/ZzReservationStatus2Badge.vue";
import sweetAlert from "@/mixins/sweetAlert";
import number from "@/mixins/number";
import user from "@/mixins/user";
import workReservationSchedule from "@/mixins/workReservationSchedule";

const DEFAULT_EMPTY_SCHEDULE = (params) => {
  return {
    id: null,
    start_datetime: '',
    end_datetime: '',
    is_mixed_loading_kbn: 0,
    schedule_id_of_mixed_loading: '',
    waste_or_services_by_schedule: [],
    assigned_staffs_by_schedule: [],
    assigned_cars_by_schedule: [],
    ...params
  }
}
export default {
  name: 'DetailSpecificDatesScheduleByCarManager',
  components: {
    WorkOrderInformationComponent,
    Layout,
    DatePicker,
    Multiselect,
    CommonTableComponent,
    ModalHistory,
    ModalScheduleCar,
    ModalScheduleStaff,
    WorkReservationSpecificDatesInformation,
    ModalTransportTreatment,
    ZzReservationStatus1Badge,
    ZzReservationStatus2Badge,
    ModalSelectWasteOrServiceModalForSchedule,
  },
  mixins: [tableSearch, sweetAlert, number, user, workReservationSchedule],
  props: {
    workReservation: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      workOrder: null,
      schedules: [],
      history_comment: '',
      errors: {},
      buttonCancelText: this.$lang.button.cancel,
      buttonDeleteText: this.$lang.button.delete,
      update_request: 0,
      schedule_id: null,
      tab: null,
    };
  },
  created() {
    this.update_request = this.$route.query.update_request ?? 0;
    this.schedule_id = this.$route.query.schedule_id ?? null;
    this.tab = this.$route.query.tab ?? null;
    this.getSchedules();
  },
  methods: {
    async getSchedules() {
      const {status, code, data} = await this.$http.get(apiEndpoints.list_schedule_by_work_reservation_edit(this.workReservationId), {
        zz_reservation_frequency_type_id: this.$constant.zzReservationFrequencyTypeId.date_specific,
      })
      if (!status) {
        return this.errorToast(data.message);
      }
      this.schedules = [...data.result];
      this.$nextTick(() => {
        this.scrollToSchedule()
      });
    },
    deleteAll() {
      if (!this.isAccessByCarManager) return;
      this.confirm(
        '',
        '',
        '予約情報を削除してもよろしいですか。'
      ).then(async (result) => {
        if (!result.isConfirmed) return;

        const {
          status,
          code,
          data
        } = await this.$http.post(apiEndpoints.delete_all_schedule_by_car_manager(this.workReservationId));

        if (!status) {
          return this.errorToast(data.message);
        }

        this.successToast("予約情報を削除しました", false, 3000);
        this.backToList();
      });
    },
    onChangeOrRequest() {
      this.confirm(
        '',
        '',
        '変更・キャンセル依頼を登録してもよろしいですか。',
        'info',
        'OK',
        'キャンセル',
        true,
        "#d33",
        "35em"
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.saveHistories();
        }
      });
    },
    async saveHistories() {
      if (!this.isAccessBySale) return;
      const schedules = this.$_.cloneDeep(this.schedules);
      schedules.forEach(item => {
        item.waste_or_services_by_schedule.forEach(x => {
          delete x.waste_or_service_by_work_order
        })
        // item.end_datetime = item.start_datetime;
        delete item.waste_or_services_by_schedule.waste_estimates_by_work_reservation;
        delete item.waste_or_services_by_schedule.waste_or_service_by_work_order;
      })
      let params = {
        work_reservation: {
          id: this.workReservation.id,
          work_order_update_requests: this.workReservation.work_order_update_requests,
        },
        schedules: schedules,
        schedule_id: this.schedule_id,
      };
      const {
        status,
        code,
        data
      } = await this.$http.post(apiEndpoints.save_histories_schedules_by_sale(this.workReservationId), params);
      if (!status) {
        if (this.$helpers.isDisplayFormError(code)) {
          this.errors = data.errors;
          return this.$nextTick(() => {
            this.scrollIntoError();
          });
        } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
          return this.errorToast(data.message);
        }
      }

      this.successToast("変更・キャンセル依頼を登録しました", false, 2000);
      this.backToList();
    },

    onConfirmSchedule(schedule){
      this.confirm(
        '',
        '',
        '確定してもよろしいですか。',
        'info',
        'OK',
        'キャンセル',
        true,
        "#d33",
        "35em"
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.confirmSchedule(schedule);
        }
      });
    },

    async confirmSchedule(schedule) {
      if (!this.isAccessByCarManager) return;
      this.isLoading = true
      const url = apiEndpoints.schedule_confirm();
      let listId = [];
      listId.push(schedule.id);
      let targetDate = schedule.start_datetime;
      let start_datetime = schedule.start_datetime;
      let end_datetime = schedule.end_datetime;
      let type = this.tab;
      let eventLength = 1;
      
      const { status, data } = await this.$http.post(url, 
      {
        start_datetime: start_datetime
        , end_datetime:end_datetime
        , type:type 
        , ids: listId
        , targetDate: targetDate
        , allEventsLength: eventLength
      });
      const isSuccessDataExists = status && data.result && data.result.schedules && data.result.schedules.length;
      if (isSuccessDataExists && !data.result.contract_warning) {
        // コンプラチェックエラーなし & 確定したものあり  
        this.successToast("受付番号 "+ schedule.id + " の配車を確定しました", false, 3000);
      } else {
        if (data.result.contract_warning) {
          // コンプラチェックエラーダイアログ表示
          this.$swal.fire({
            icon: "warning",
            html: data.result.contract_warning_message,
            width: data.result.width_alert || '70em',
          })
          .then(() => {
            // その後、確定したものがあればwarningのtoast表示
            if (isSuccessDataExists) {
              this.warningToast(eventDateMD + " 配車が確定できませんでした", false, 3000);
            }
          });
        }
      }

      this.isLoading = false;
      this.reloadSchedules();
    },

    onCancelSchedule(schedule){

      let cancelLabel = schedule.zz_reservation_status1.id == this.$constant.zz_reservation_status_1.cancel ? 'キャンセル解除':'キャンセル';

      this.confirm(
        '',
        '',
        cancelLabel + 'してもよろしいですか。',
        'info',
        'OK',
        'キャンセル',
        true,
        "#d33",
        "35em"
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.cancelSchedule(schedule);
        }
      });
    },

    async cancelSchedule(schedule) {
      if (!this.isAccessByCarManager) return;
      let params = {
        schedules: this.schedules,
      };
      const {status, code, data} = await this.$http.post(apiEndpoints.cancel_schedule_by_car_manager(schedule.id), params)
      if (!status) {
        return this.errorToast(data.message);
      }
      this.reloadSchedules();
    },
    async deleteSchedule(schedule) {
      if (!this.isAccessByCarManager) return;
      if (schedule.new) {
        const index = this.schedules.findIndex(x => x.id === schedule.id);
        if (index === -1) return;

        this.schedules.splice(index, 1);
        return;
      }
      this.confirm(
        '',
        '',
        '受付番号'+schedule.id+'の予約受付データを削除してもよろしいですか。'
      ).then(async (result) => {
        if (!result.isConfirmed) return;

        const {status, code, data} = await this.$http.post(apiEndpoints.delete_schedule_by_car_manager(schedule.id));

        if (!status) {
          return this.errorToast(data.message);
        }
        this.reloadSchedules();
      });
    },
    addNewSchedule() {
      if (!this.isAccessByCarManager) return;
      const newSchedule = DEFAULT_EMPTY_SCHEDULE({
        zz_reservation_status_2_id: this.$constant.zz_reservation_status_2.unnecessary,
        new: true,
        id: this.$moment().unix(),
        is_mixed_loading_kbn: this.workOrder.mixed_loading_kbn === '2' ? 1 : 0,
        zz_work_order_type_id: this.workOrder.zz_work_order_type_id
      });
      let waste_or_services_by_schedule = [];
      this.workReservation.wastes_or_services_by_work_reservation.forEach(item => {
        let waste_or_services_by_work_reservation = this.$_.cloneDeep(item);
        // if (waste_or_services_by_work_reservation.waste_or_service_by_work_order.service) {
          // サービスの場合は何故か空を渡しているがそのあたりは気にせず明細を作るようにしたい
          // waste_or_services_by_work_reservation.waste_estimates_by_schedule = [];
          //
        // } else {
          waste_or_services_by_work_reservation.waste_estimates_by_schedule = waste_or_services_by_work_reservation.waste_estimates_by_work_reservation.map(x => {
            return {
              ...x,
              quantity: (x.pivot.reservation_quantity == 0)?null:x.pivot.reservation_quantity,
              number_of_rental_containers: x.pivot.reservation_number_of_rental_containers,
            }
          });
        // }
        waste_or_services_by_work_reservation.disposal_sites_by_waste_id = waste_or_services_by_work_reservation?.waste_or_service_by_work_order?.disposal_sites_by_waste_id
        waste_or_services_by_work_reservation.disposal_site = waste_or_services_by_work_reservation?.waste_or_service_by_work_order?.disposal_site
        waste_or_services_by_work_reservation.number_of_manifest = waste_or_services_by_work_reservation.number_of_manifests
        waste_or_services_by_schedule.push({...waste_or_services_by_work_reservation})
      })

      newSchedule.waste_or_services_by_schedule = waste_or_services_by_schedule;

      this.schedules.unshift(newSchedule);
    },
    openHistoryModal(schedule) {
      if (!this.isAccessByCarManager) return;
      this.$refs.modal_history.openModal(schedule.id);
    },
    async onSubmit(onlyValidation = true, fromCarOverlap = false) {
      this.errors = {};
      const schedules = this.$_.cloneDeep(this.schedules);
      schedules.forEach(item => {
        // item.end_datetime = item.start_datetime;
        delete item.waste_or_services_by_schedule.waste_estimates_by_work_reservation;
      })

      // サービス・廃棄物見積明細のうち少なくとも1つは入力しているかチェック
      for (let index_1 = 0; index_1 < schedules[0].waste_or_services_by_schedule.length; index_1++) {
        const wasteOrServiceBySchedule = schedules[0].waste_or_services_by_schedule[index_1];
        let sumQuantity = 0;
        wasteOrServiceBySchedule.waste_estimates_by_schedule.forEach(estimate => {
          const quantity = estimate.quantity ? parseFloat(estimate.quantity) : 0;
          sumQuantity += quantity;
        })

        if(sumQuantity === 0) {
          for(let index_2 = 0; index_2 < wasteOrServiceBySchedule.waste_estimates_by_schedule.length; index_2++) {
            this.errors['schedules.0.waste_or_services_by_schedule.' + index_1 + '.waste_estimates_by_schedule.' + index_2 + '.quantity'] = ['少なくとも1つ数量を入力してください。'];
          }
          if(wasteOrServiceBySchedule.waste_estimates_by_schedule.length == 1) {
            this.errors['schedules.0.waste_or_services_by_schedule.' + index_1 + '.waste_estimates_by_schedule.0.quantity'] = ['0より大きい数字を入力してください。'];
          }
          return;
        }
      }

      let params = {
        work_reservation: {
          id: this.workReservation.id,
        },
        schedules: schedules,
        comment_of_schedule_update: this.history_comment,
        only_validation: onlyValidation,
        update_request : this.update_request,
        schedule_id: this.schedule_id,
        from_car_overlap: fromCarOverlap
      };
      const url = apiEndpoints.update_schedules_by_work_reservation(this.workReservationId)

      const {status, data, code} = await this.$http.post(url, params);

      if (status) {
        // バリデーション時、もしくは車両重複ダイアログから来てコンプライアンスエラーがある場合のみ
        if (onlyValidation || (fromCarOverlap && data.result.compliance_valid===false)) {
          return this.handleConfirmUpdate(data);
        }
        this.successToast("予約の修正が成功しました。", false, 2000);
        this.backToList();
      }

      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        if (this.errors['overlap_schedules'] && this.errors['overlap_schedules'].length) {
          this.handleOverlapSchedulesError(this.errors['overlap_schedules']);
        }
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        return this.errorToast(data.message, false, 3000);
      }
    },
    handleConfirmUpdate(data) {

      let confirmMsg = "";
      let width ='32em';
      if(data.result.compliance_valid===false){
        confirmMsg+=data.result.message+"<br>";
        width='50em';
      }
      confirmMsg+='スケジュールを登録してもよろしいですか。';
      this.confirm(
        confirmMsg,
        '',
        '',
        'info',
        'OK',
        'キャンセル',
        true,
        '#d33',
        width
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.onSubmit(false);
        }
      });
    },
    handleOverlapSchedulesError(errors) {
      let message = [
          ...errors,
        'の車両に作業日時の重複があります。',
        'スケジュールを登録してもよろしいですか。',
      ].join('<br>');
      this.confirm(
        '',
        '',
        message,
        'warning',
        'OK',
        'キャンセル'
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.onSubmit(false, true);
        }
      });
    },
    reloadSchedules() {
      this.getSchedules();
    },
    scrollIntoError() {
      const el = document.querySelector(".error-message");
      el.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
    },
    canUpdateZzReservationStatus2(schedule) {
      // newの場合はサーバーからcan_update_zz_reservation_status_2を取得していないので出さないようにしていると思われる
      //return !schedule.new && schedule.can_update_zz_reservation_status_2;
      if(!schedule.new){
        return schedule.can_update_zz_reservation_status_2;
      }
      // newの場合も出したいので、ここで判断する。
      // ここで判断するならcan_update_zz_reservation_status_2をわざわざ返す必要性もない気はするが
      return schedule.zz_work_order_type_id == this.$constant.work_order_type.transportation
            || schedule.zz_work_order_type_id == this.$constant.work_order_type.discharge
            || (schedule.zz_work_order_type_id == this.$constant.work_order_type.transshipment_storage && schedule.transport_and_hold_section == 2);
    },
    canBeConfirm(schedule) {
      // 予約情報画面では確定不可能
      // 確定済みは確定不可能
      // キャンセル中は確定不可能
      // 最低限エラーチェックはしているので個々のでチェックはある程度にして押させてしまっていいか
      // 追加中のスケジュールもダメ
      return this.isAccessByCarManager 
      && this.canUserEdit() 
      && ![this.$constant.zz_reservation_status_1.confirm
        ,this.$constant.zz_reservation_status_1.cancel
        ,this.$constant.zz_reservation_status_1.change_request
      ].includes(schedule.zz_reservation_status_1_id)
      && this.schedule_id
      && !schedule['new']
    },
    canBeCancel(schedule) {
      return this.isAccessByCarManager && this.canUserEdit() && !schedule['new']
        && ![this.$constant.zz_reservation_status_1.confirm].includes(schedule.zz_reservation_status_1_id)
    },
    canBeDelete(schedule) {
      return this.isAccessByCarManager && this.canUserEdit()
        && ![this.$constant.zz_reservation_status_1.confirm].includes(schedule.zz_reservation_status_1_id)
    },
    canBeDrop() {
      return this.isAccessByCarManager && this.canUserEdit()
        && (this.schedules.filter(schedule => schedule.zz_reservation_status_1_id 
        == this.$constant.zz_reservation_status_1.confirm).length == 0)
    },
    canBeUpdate(schedule) {
      return ![this.$constant.zz_reservation_status_1.confirm, this.$constant.zz_reservation_status_1.cancel]
        .includes(schedule.zz_reservation_status_1_id)
    },
    canBeViewHistories(schedule) {
      return !schedule['new'];
    },
    isScheduleConfirmed(){
      // 紐づくスケジュールが全て確定なら true
      return (this.schedules.filter(schedule => schedule.zz_reservation_status_1_id 
        !== this.$constant.zz_reservation_status_1.confirm).length === 0);
    },
    setMinNumber (e, number = 0) {
      if (e.target.value < number) e.target.value = number;
    },
    disableByWorkOrder(schedule){
      //・作業分類：処分
      //・作業分類：排出 の他社運搬
      //・作業分類：積替保管 の他社運搬 (区間1,2共通)
      // 従業員・車両選択をOFF
      return (schedule.zz_work_order_type_id == this.$constant.work_order_type.disposal) ||
      (schedule.zz_work_order_type_id == this.$constant.work_order_type.discharge && 
      (schedule.vendor !== undefined && schedule.vendor.zz_own_id == this.$constant.zzOwnId.is_not_own)
      ) ||
      (schedule.zz_work_order_type_id == this.$constant.work_order_type.transshipment_storage && 
      (schedule.vendor !== undefined && schedule.vendor.zz_own_id == this.$constant.zzOwnId.is_not_own)
      )
    },
    scrollToSchedule() {
      let id = this.$route.query.schedule_id ?? null
      if (!id) {
        return
      }
      const schedule_element = document.getElementById(`schedule_${id}`);
      if (schedule_element) {
        schedule_element.scrollIntoView({behavior: 'smooth'});
      }
    },
    quantityConfirmationUnit(wasteOrService) {
      if (!wasteOrService.zz_quantity_confirmation_unit) return '';

      return wasteOrService.zz_quantity_confirmation_unit.jw_unit;
    },
    isDisplayMeasurementQuantity(wasteOrService) {
      return wasteOrService.measurement_quantity !== null
        && wasteOrService.measurement_quantity !== undefined
        && wasteOrService.zz_quantity_confirmation_unit;
    },
    isTransportAndHold(schedule) {
      return schedule.zz_work_order_type_id == this.$constant.work_order_type.transshipment_storage;
    },
    isNotOwnVendorSite(wasteOrService, schedule) {
      if (this.isTransportAndHold(schedule) && schedule.transport_and_hold_section === 2) {
        // 積替保管区間2の場合は他社処分
        return true;
      }
      // それ以外は区間1の運搬先の委託先事業場の自社フラグで判定
      return wasteOrService.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment.zz_own_id === '0';
    }
  },
  computed: {
    previousRouteName() {
      if (this.$route.name === 'projects.work_reservations.schedule.detail_for_sale') {
        return 'schedules';
      }

      return 'schedule.car.list';
    },
    isAccessBySale() {
      return this.$route.name === 'projects.work_reservations.schedule.detail_for_sale'
    },
    isAccessByCarManager() {
      return this.$route.name === 'projects.work_reservations.schedule.detail'
    },
  },
  watch: {
    workReservation: {
      handler: function(newVal) {
        if (!newVal) return;
        this.workReservation = newVal;
        this.workOrder = newVal?.work_order;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<template>
  <Layout>
    <div class="scroll-area">
      <WorkOrderInformationComponent
        v-if="workReservation && workReservation.work_order"
        :workOrder="workReservation.work_order"
      />
      <WorkReservationSpecificDatesInformation
        v-if="workReservation"
        :work-reservation="workReservation"
        :waste-or-services-by-work-reservation="workReservation.wastes_or_services_by_work_reservation"
        :disable-comment="disableComment"
        :display-user-created="isAccessByCarManager"
        :display-time-reservation-date="isAccessByCarManager"
      />
      <ModalHistory
        v-if="isAccessByCarManager"
        ref="modal_history"
      />
      <ModalScheduleCar
        v-if="isAccessByCarManager"
        ref="vehicleList"
        @dataSelected="onSelectedVehicles"
      />
      <ModalScheduleStaff
        v-if="isAccessByCarManager"
        ref="staffList"
        @dataSelected="onSelectedStaffs"
      />
      <ModalSelectWasteOrServiceModalForSchedule
        ref="modalSelectWasteOrService"
        :work-order-id="workReservation.work_order_id"
        @dataSelected="onSelectedWastesOrService"
      />
      <ModalTransportTreatment
        v-if="isAccessByCarManager"
        ref="transportsTreatments"
        @dataSelected="onSelectedTransportTreatment"
      />
      <div class="mb-2">
        <div>
          <b-button
            variant="primary"
            :disabled="!canAddWasteOrService"
            @click="openSelectWasteOrServiceModal()"
            v-if="canUserEdit()"
          >
          <i class="fa fa-plus"></i>
            廃棄物・サービスを追加する
          </b-button>
        </div>
        <div class="mt-2">
          <b-button
            variant="primary"
            :disabled="isAccessBySale"
            @click="addNewSchedule"
            v-if="canUserEdit()"
          >
          <i class="fa fa-plus"></i>
            予約受付データを追加する
          </b-button>
        </div>
      </div>
      <b-card
        v-for="(schedule, index) in schedules"
        class="reservation-reception"
        :id="`schedule_${schedule.id}`"
        :key="`schedule_${schedule.id}`"
      >
        <div
          v-if="errors[`schedules.${index}`]"
          class="error-message"
        >
          {{ errors[`schedules.${index}`][0] }}
        </div>
        <b-row>
          <b-col cols="6">
            <div class="title">■ 予約受付内容</div>
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end gap-2">
              <b-button
                variant="success"
                v-if="canBeConfirm(schedule)"
                @click="onConfirmSchedule(schedule)"
              >
                <i class="fas fa-check"></i> 確定
              </b-button>
              <b-button
                variant="warning"
                v-if="canBeCancel(schedule)"
                @click="onCancelSchedule(schedule)"
              >
                <i class="fas fa-times"></i> {{ buttonCancelText }}
              </b-button>
              <b-button
                v-if="canBeDelete(schedule) && canUserDelete()"
                :disabled="isAccessBySale || schedules.length < 2"
                @click="deleteSchedule(schedule)"
                class="btn-custom-red"
              >
                <i class="fas fa-eraser"></i> {{ buttonDeleteText }}
              </b-button>
              <b-button
                v-if="canBeViewHistories(schedule)"
                :disabled="isAccessBySale"
                @click="openHistoryModal(schedule)"
                variant="info"
              >
                <i class="fas fa-history"></i> 履歴
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="1">受付番号</b-col>
          <b-col class="d-flex gap-2">
            <div>{{ !schedule.new ? schedule.id : '' }}</div>
            <ZzReservationStatus1Badge
              v-if="schedule.zz_reservation_status1"
              :status-label="schedule.zz_reservation_status1.reservation_status_1"
              :status-id="schedule.zz_reservation_status1.id"
            />
            <div
              v-if="isTransportAndHold(schedule)"
              class="badge transport_and_hold"
            >
              区間{{ schedule.transport_and_hold_section }}
            </div>
            <ZzReservationStatus2Badge
              v-if="schedule.zz_reservation_status2"
              :status-label="schedule.zz_reservation_status2.reservation_status_2"
              :status-id="schedule.zz_reservation_status2.id"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="1 align-self-center">作業予定日時</b-col>
          <b-col class="d-flex gap-2 col-4 align-items-baseline">
            <template v-if="isAccessByCarManager">
              <div>
                <date-picker
                  :disabled="!canBeUpdate(schedule)"
                  v-model="schedule.start_datetime"
                  lang="ja"
                  placeholder="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  value-type="YYYY-MM-DD"
                  position="left"
                  :clearable="false"
                  :editable="false"
                ></date-picker>
                <div
                  v-if="errors[`schedules.${index}.start_datetime`]"
                  class="error-message text-nowrap"
                >
                  {{ errors[`schedules.${index}.start_datetime`][0] }}
                </div>
              </div>
              <div class="align-self-center">～</div>
              <div>
                <date-picker
                  :disabled="!canBeUpdate(schedule)"
                  v-model="schedule.end_datetime"
                  lang="ja"
                  placeholder="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  value-type="YYYY-MM-DD"
                  position="left"
                  :clearable="false"
                  :editable="false"
                ></date-picker>
                <div
                  v-if="errors[`schedules.${index}.end_datetime`]"
                  class="error-message"
                >
                  {{ errors[`schedules.${index}.end_datetime`][0] }}
                </div>
              </div>
            </template>
            <template v-else>
              {{ schedule.start_datetime | longDate }} {{ schedule.start_datetime | time }}
              ～
              {{ schedule.end_datetime | longDate }} {{ schedule.end_datetime | time }}
            </template>
          </b-col>
        </b-row>
        <b-row class="mt-2" v-if="isAccessByCarManager">
          <b-col cols="1 align-self-center">作業時間</b-col>
          <b-col class="d-flex gap-2 col-4 align-items-baseline">
            <div>
              <date-picker
                :disabled="!canBeUpdate(schedule)"
                v-model="schedule.start_time"
                type="time"
                placeholder="HH:mm"
                format="HH:mm"
                value-type="HH:mm"
                position="left"
                :clearable="false"
                :editable="true"
              ></date-picker>
              <div
                v-if="errors[`schedules.${index}.start_time`]"
                class="error-message text-nowrap"
              >
                {{ errors[`schedules.${index}.start_time`][0] }}
              </div>
            </div>
            <div class="align-self-center">～</div>
            <div>
              <date-picker
                :disabled="!canBeUpdate(schedule)"
                v-model="schedule.end_time"
                type="time"
                placeholder="HH:mm"
                format="HH:mm"
                value-type="HH:mm"
                position="left"
                :clearable="false"
                :editable="true"
              ></date-picker>
              <div
                v-if="errors[`schedules.${index}.end_time`]"
                class="error-message text-nowrap"
              >
                {{ errors[`schedules.${index}.end_time`][0] }}
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="schedule.vendor && schedule.vendor.zz_own_id === '0'" class="mt-4 mb-2">
          <b-col>
            運搬事業者：{{ schedule.vendor.name_abbreviated }}
          </b-col>
        </b-row>
        <b-button
          :disabled="isAccessBySale || !canBeUpdate(schedule) || disableByWorkOrder(schedule) || !canUserEdit()"
          variant="primary mt-2"
          @click="openSelectAssignedCarsModal(schedule)"
        >
          <i class="fa fa-list-alt"></i>
          車両を選択する
        </b-button>
        <div class="selected-vehicles d-flex gap-2 mt-2 flex-wrap">
          <b-badge
            v-for="(assigned_car, indexCar) in schedule.assigned_cars_by_schedule"
            :key="`assigned_car_${schedule.id}_${assigned_car.id}`"
            variant="primary"
          >
            {{ displayAssignedCar(assigned_car) }}
            <span
              v-if="isAccessByCarManager"
              @click="removeAssignedCar(schedule, assigned_car)"
              class="badge badge-light badge-icon-custom"
            ><i class="fas fa-times"></i></span>
          </b-badge>
        </div>
        <b-button
          :disabled="isAccessBySale || !canBeUpdate(schedule) || disableByWorkOrder(schedule) || !canUserEdit()"
          variant="primary mt-2"
          @click="openSelectAssignedStaffsModal(schedule)"
        >
          <i class="fa fa-list-alt"></i>
          従業員を選択する
        </b-button>
        <div class="selected-employees d-flex gap-3 mt-2">
          <b-badge
            v-for="(staff, indexStaff) in schedule.assigned_staffs_by_schedule"
            :key="`staff_${schedule.id}_${staff.id}`"
            variant="primary"
          >
            {{ staff.user_name }}
            <span
              v-if="isAccessByCarManager"
              @click="removeAssignedStaff(schedule, staff)"
              class="badge badge-light badge-icon-custom"
            ><i class="fas fa-times"></i></span>
          </b-badge>
        </div>
        <div
          v-if="errors[`schedules.${index}.assigned_staffs_by_schedule`]"
          class="error-message text-nowrap"
        >
          {{ errors[`schedules.${index}.assigned_staffs_by_schedule`][0] }}
        </div>
        <div class="custom-radio-group mt-3" v-if="canUpdateZzReservationStatus2(schedule)">
          <b-form-radio-group
            :disabled="isAccessBySale || !canBeUpdate(schedule)"
            class="radio-group"
            text-field="reservation_status_2"
            value-field="id"
            v-model="schedule.zz_reservation_status_2_id"
            :options="zzReservationStatus2"
          ></b-form-radio-group>
        </div>
        <div class="d-flex gap-5 mt-2">
          <div class="d-flex gap-2">
            <div>合積</div>
            <b-form-checkbox
              :disabled="isAccessBySale || !canBeUpdate(schedule)"
              :id="`is_mixed_loading_kbn${index}`"
              v-model="schedule.is_mixed_loading_kbn"
              :value="schedule.is_mixed_loading_kbn"
              :name="`is_mixed_loading_kbn${index}`"
              value="1"
              unchecked-value="0"
            >
              あり
            </b-form-checkbox>
          </div>
          <div class="d-flex gap-2">
            <div>合積受付番号</div>
            <div>
              <b-form-input
                type="number"
                v-model="schedule.schedule_id_of_mixed_loading"
                :disabled="isAccessBySale || !canBeUpdate(schedule)"
              />
              <div
                v-if="errors[`schedules.${index}.schedule_id_of_mixed_loading`]"
                class="error-message"
              >
                {{ errors[`schedules.${index}.schedule_id_of_mixed_loading`][0] }}
              </div>
            </div>
          </div>

        </div>

        <div class="title mt-2">■ 作業内容</div>
        <div
          v-for="(waste_or_service_by_schedule, index_waste_or_service) in schedule.waste_or_services_by_schedule"
          :key="`waste_or_service_by_schedule_${schedule.id}_${waste_or_service_by_schedule.id}`"
          class="work-detail mt-3 mb-4"
        >
          <div class="infomations d-flex gap-3">
            <div class="number">{{ index_waste_or_service + 1 }}.</div>
            <div class="waste-work-name">廃棄物・サービス名
              <template v-if="waste_or_service_by_schedule.waste_or_service_by_work_order.waste">
              <router-link
                class="text-decoration-underline"
                target="_blank"
                :to="{ name: 'projects.sales.wastes.detail',
                    params: {
                      id: waste_or_service_by_schedule.waste_or_service_by_work_order.waste.case_id,
                      waste_id: waste_or_service_by_schedule.waste_or_service_by_work_order.waste.id}
                }">
                <span>{{
                  displayWasteOrServiceName(waste_or_service_by_schedule)
                }}</span>
                </router-link>
                </template>
                <template v-else>
                <router-link
                  class="text-decoration-underline"
                  target="_blank"
                  :to="{ name: 'projects.sales.works.detail',
                      params: {
                        id: waste_or_service_by_schedule.waste_or_service_by_work_order.service.case_id,
                        work_id: waste_or_service_by_schedule.waste_or_service_by_work_order.service.id}
                  }">
                  <span>{{
                    displayWasteOrServiceName(waste_or_service_by_schedule)
                  }}</span>
                  </router-link>
                </template>
            </div>
            <template
              v-if="waste_or_service_by_schedule && waste_or_service_by_schedule.waste_or_service_by_work_order.waste">
              <div class="waste-type">
                廃棄物種類
                <span>{{ displayWasteCategory(waste_or_service_by_schedule) }}</span>
              </div>
              <div class="manifest">
                <label class="label-manifest">マニフェスト</label>
                <b-form-input
                        :disabled="isAccessBySale || !canBeUpdate(schedule)"
                        @keyup="setMinNumber($event)"
                        :id="`waste_or_service_by_schedule_number_of_manifest_${waste_or_service_by_schedule.id}`"
                        type="number"
                        min="0"
                        v-model="waste_or_service_by_schedule.number_of_manifest"
                        class="input-manifest"
                ></b-form-input>
                <span>枚</span>
                <template
                  v-if="errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.number_of_manifest`]"
                >
                  <br>
                  <span class="error-message">{{ errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.number_of_manifest`][0] }}</span>
                </template>
              </div>
              <div class="measurement-quantity" v-if="isDisplayMeasurementQuantity(waste_or_service_by_schedule)">
                予定重量
                <span>{{waste_or_service_by_schedule.measurement_quantity | number}}</span>
                <span>{{quantityConfirmationUnit(waste_or_service_by_schedule)}}</span>
              </div>
            </template>
          </div>
          <template
            v-if="waste_or_service_by_schedule && waste_or_service_by_schedule.waste_or_service_by_work_order.waste">
            <div class="d-flex gap-2 transport-destination mt-2 align-items-center w-50">
              <div class="label text-nowrap">運搬先・処分方法</div>
              <b-form-input
                disabled
                :value="getDestinationWasteOrServiceBySchedule(waste_or_service_by_schedule, schedule)"
              ></b-form-input>
              <b-button
                @click="openSelectTransportTreatmentModal(waste_or_service_by_schedule, schedule)"
                :disabled="isAccessBySale || isNotOwnVendorSite(waste_or_service_by_schedule, schedule) || !canBeUpdate(schedule) || !canUserEdit()"
                variant="primary text-nowrap">
                <i class="fa fa-list-alt"></i>
                変更
              </b-button>
            </div>
          </template>
          <div class="mt-3">
            <CommonTableComponent
              :height-class="`table-wrapper-500`"
            >
              <thead class="table-light">
              <tr>
                <th
                  v-for="(header, indexHeader) in work_detail_header"
                  :key="`table_wastes_or_services_by_work_reservation_header_${schedule.id}_${indexHeader}`"
                  :class="getHeaderClass(header)"
                >
                <span>
                  {{ header.text }}
                </span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="(waste_estimate_by_schedule, index_waste_estimates_by_schedule) in waste_or_service_by_schedule.waste_estimates_by_schedule"
                :key="`waste_estimate_by_schedule_${schedule.id}_${waste_or_service_by_schedule.id}_${waste_estimate_by_schedule.id}`"
              >
                <td>
                  {{ waste_estimate_by_schedule.estimate_cd }}
                </td>
                <td>
                  {{ waste_estimate_by_schedule.invoice_product_name }}
                </td>
                <td>
                  <template v-if="isAccessByCarManager">
                    <b-form-input
                      :disabled="!canBeUpdate(schedule)"
                      @keyup="setMinNumber($event)"
                      :id="`waste_estimates_by_schedule_quantity_${waste_estimate_by_schedule.id}`"
                      type="number"
                      min="0"
                      v-model="waste_estimate_by_schedule.quantity"
                    ></b-form-input>
                    <div
                      v-if="errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.${index_waste_estimates_by_schedule}.quantity`]"
                      class="error-message"
                    >
                      {{ errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.${index_waste_estimates_by_schedule}.quantity`][0] }}
                    </div>
                  </template>
                  <template v-else>
                    {{ waste_estimate_by_schedule.quantity }}
                  </template>

                </td>
                <td>
                  {{ waste_estimate_by_schedule.zz_unit.unit }}
                </td>
                <td>
                  <template v-if="isAccessByCarManager">
                    <b-form-input
                      :disabled="!canBeUpdate(schedule) || !waste_or_service_by_schedule.waste_or_service_by_work_order.waste_id"
                      :id="`waste_estimates_by_schedule_number_of_rental_containers${waste_estimate_by_schedule.id}`"
                      type="text"
                      maxLength="50"
                      v-model="waste_estimate_by_schedule.number_of_rental_containers"
                    ></b-form-input>
                    <div
                      v-if="errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.${index_waste_estimates_by_schedule}`]"
                      class="error-message"
                    >
                      {{ errors[`schedules.${index}.waste_or_services_by_schedule.${index_waste_or_service}.waste_estimates_by_schedule.${index_waste_estimates_by_schedule}`][0] }}
                    </div>
                  </template>
                  <template v-else>
                    {{ waste_estimate_by_schedule.number_of_rental_containers }}
                  </template>
                </td>
              </tr>
              <tr v-if="!waste_or_service_by_schedule.waste_estimates_by_schedule.length">
                <td colspan="6" class="text-center">
                  データなし。
                </td>
              </tr>
              </tbody>
            </CommonTableComponent>
          </div>
          <div class="mt-1">
            <label>事業者向け備考</label>
            <b-form-textarea
              :disabled="isAccessBySale || !canBeUpdate(schedule)"
              rows="2"
              max-rows="6"
              v-model="waste_or_service_by_schedule.comment_to_discharger_site_user"
            ></b-form-textarea>
          </div>
          <div class="mt-1">
            <label>作業者向け備考</label>
            <b-form-textarea
              :disabled="isAccessBySale || !canBeUpdate(schedule)"
              rows="2"
              max-rows="6"
              v-model="waste_or_service_by_schedule.comment_to_user"
            ></b-form-textarea>
          </div>
        </div>
      </b-card>
      <b-card class="history-comment" v-if="isAccessByCarManager">
        <div class="title">■ 履歴用コメント</div>
        <b-form-input
          v-model="history_comment"
          class="mt-2"
        ></b-form-input>
        <div
          v-if="errors[`comment_of_schedule_update`]"
          class="error-message"
        >
          {{ errors[`comment_of_schedule_update`][0] }}
        </div>
      </b-card>
      <b-card class="comment-fixed-custom">
        <div class="title">■ 変更依頼コメント</div>
        <b-form-input
          :disabled="disableComment"
          id="comment_reservation"
          v-model="workReservation.work_order_update_requests"
        />
        <div
          v-if="errors[`work_reservation.work_order_update_requests`]"
          class="error-message"
        >
          {{ errors[`work_reservation.work_order_update_requests`][0] }}
        </div>
      </b-card>

    </div>
    <div class="button-fixed-custom">
      <div class="list-button d-flex gap-2">
        <b-button
          variant="primary"
          @click="onSubmit()"
          v-if="isAccessByCarManager && canUserEdit()"
        >
          <i class="fas fa-pencil-alt"></i> 登録
        </b-button>
        <b-button
          v-if="isAccessBySale && canUserEdit()"
          @click="onChangeOrRequest()"
          variant="warning"
          class="change-cancel-button"
          :disabled="isScheduleConfirmed()"
        >
          <i class="fas fa-pencil-alt"></i> 変更・キャンセル依頼
        </b-button>
        <router-link
          :to="{ name: previousRouteName }"
          tag="button"
          class="btn btn-primary waves-effect waves-light back-button"
        >
          <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
        </router-link>
        <div class="d-flex justify-content-end delete-button-area">
          <b-button
          v-if="isAccessByCarManager && canUserDelete()"
          @click="deleteAll()"
          class="btn-custom-red delete-button"
          :disabled="!canBeDrop()"
          >
          <i class="fas fa-eraser"></i> {{ buttonDeleteText }}
          </b-button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped lang="scss">
.scroll-area {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  overflow-x: hidden;
}

.work-instruction-content,
.reservation-contents,
.reservation-reception {
  .title {
    font-size: 16px;
    font-weight: 700;
  }
}

.work-instruction-content {
  .block-1,
  .block-2 {
    div > span {
      margin-left: 10px;
    }
  }

  .block-1 {
    a {
      text-decoration: underline !important;
      color: #495057;
    }
  }

  .block-3 {
    gap: 30px;

    .number-of-workers {
      margin-right: 20px;

      span {
        margin-left: 20px;
      }
    }
  }

  .block-4 {
    .vehicle-list {
      margin-left: 48px;
    }
  }
}

.reservation-contents {
  .block-1,
  .block-2 {
    div > span {
      margin-left: 10px;
    }
  }

  .block-5,
  .block-6 {
    span {
      margin-left: 10px;
    }
  }
}

.reservation-reception {
  .work-detail {
    .infomations {
      div > span {
        margin-left: 5px;
      }

      .waste-work-name {
        margin-left: 10px;
      }

      .waste-type, .manifest, .measurement-quantity {
        margin-left: 20px;
      }

      .manifest {
        margin-top: -10px;
      }
    }
  }

  .transport-destination {
    margin-left: 35px;
  }
}

.badge {
  font-size: 14px;
  padding: 8px 16px;
  background-color: #14A5FD;
}

.badge.badge-icon-custom {
  color: #14A5FD;
  padding: 2px 4px;
  background-color: #f8f9fa;
  border-radius: 50%;
  font-weight: 700;
  cursor: pointer;
}

.transport_and_hold {
  background-color: #891457;
}

.custom-radio-group .radio-group {
  margin-left: unset;
}

.multiselect {
  width: 60%;
}

.button-fixed-custom {
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 10;
  margin-bottom: 20px;
  width:50%;
}
.comment-fixed-custom {
  position: sticky;
  z-index: 10;
  bottom: 0;
  border-top: 2px solid #eff2f7;
}

.delete-button-area {
  width: 77%;
}

.delete-button {
  width: 72px;
}

.change-cancel-button {
  width: 200px;
}

.back-button {
  width: 77px;
}

.input-manifest {
  display: inline;
  width: 65px;
  margin-left: 10px;
}
</style>
